import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { useIncomeHistoryFieldVisibility } from "@Client/@Composables/application-standalone/pages/income-history/useIncomeHistoryFieldVisibility";
import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import { APPLICATION_PATH } from "@Client/@Utils/enums/application-paths";
import i18n from "@Shared/@i18n";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import { computed, ref } from "@vue/composition-api";
export const useIncomeHistoryHelpers = () => {
  const {
    addNestedField,
    removeNestedField,
    unshiftNestedField
  } = useBindApplication();
  const {
    applicationHasCoApplicants
  } = useApplicantHelpers();
  const addEmptyIncomeHistory = applicantIndex => {
    const currentApplicantPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    addNestedField(currentApplicantPath + "[employment]");
  };
  const addRetiredEmploymentHistory = applicantIndex => {
    const currentApplicantPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    unshiftNestedField(currentApplicantPath + "[employment]");
  };
  const deleteIncomeHistory = (applicantIndex, incomeIndex) => {
    const currentApplicantPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    removeNestedField(currentApplicantPath + "[employment]", incomeIndex);
  };
  const employmentSummarySubtitle = employment => {
    var _context;
    const employerName = employment["employer-name"] || "";
    const incomeAmount = formatMoneyValueLong(employment["income-amount"] || "");
    const currentEmployment = employment["current-job"] ? i18n.t("global.words.current") : "";
    return _filterInstanceProperty(_context = [employerName, incomeAmount, currentEmployment]).call(_context, el => !!el).join(" | ");
  };
  const applicantHasEmployment = employment => employment && !!employment.length;
  const isIncomeHistorySectionVisibleForMainApplicant = computed(() => {
    const {
      isIncomeHistorySectionVisibleForApplicant
    } = useIncomeHistoryFieldVisibility({
      applicantIndex: ref(0),
      employmentIndex: ref(0)
    });
    return isIncomeHistorySectionVisibleForApplicant.value;
  });
  const isIncomeHistorySectionVisibleForCoApplicants = computed(() => {
    if (!applicationHasCoApplicants.value) return false;
    const {
      isIncomeHistorySectionVisibleForApplicant
    } = useIncomeHistoryFieldVisibility({
      applicantIndex: ref(1),
      employmentIndex: ref(0)
    });
    return isIncomeHistorySectionVisibleForApplicant.value;
  });
  return {
    addEmptyIncomeHistory,
    deleteIncomeHistory,
    employmentSummarySubtitle,
    applicantHasEmployment,
    addRetiredEmploymentHistory,
    isIncomeHistorySectionVisibleForMainApplicant,
    isIncomeHistorySectionVisibleForCoApplicants
  };
};